/**
 * Tax Rate type values.
 */
export enum TaxRateTypeEnum {
	STANDARD_TAX_RATE = 'standardTaxRate',
	EXEMPT_TAX_RATE = 'exemptTaxRate',
	REDUCED_TAX_RATE_1 = 'reducedTaxRate1',
	REDUCED_TAX_RATE_2 = 'reducedTaxRate2',
	REDUCED_TAX_RATE_3 = 'reducedTaxRate3',
	ZERO_TAX_RATE = 'zeroTaxRate',
	REVERSE_CHARGE_TAX_RATE = 'reverseChargeTaxRate',
}
